// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html[data-v-7482526b] :not(.v-icon):not(i.material-icons):not(span.material-icons){font-family:DM Sans,\"sans-serif\"}@media (max-width:768px){div.toast-outer.toast-position-bottom[data-v-7482526b]{max-width:75%!important}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
